import Swiper from "../../node_modules/swiper";
import { Autoplay } from '../../node_modules/swiper/modules/';

// Note I've not included Navigation intentionally

function runSwiper() {
  if ($(".js-swiper-slideshow").length > 0) {
    $(".js-swiper-container").each(function (i) {

      new Swiper($(this)[0], {
        modules: [Autoplay],
        // Disable preloading of all images
        preloadImages: false,
        // Enable lazy loading
        lazy: true,
        // watchOverflow: true,
        grabCursor: true,
        autoplay: {
          delay: 5000
        },
        loop: true,
        // effect: 'fade',
        // fadeEffect: {
        //   crossFade: true
        // },
        // lazy: {
        //   loadPrevNext: true
        // },

      });
    });
  }
}

export { runSwiper };
